import { render } from "./HighlightsSection.vue?vue&type=template&id=ec8b7a50&scoped=true"
import script from "./HighlightsSection.vue?vue&type=script&lang=js"
export * from "./HighlightsSection.vue?vue&type=script&lang=js"

import "./HighlightsSection.vue?vue&type=style&index=0&id=ec8b7a50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8b7a50"]])

export default __exports__